import html2canvas from "html2canvas";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { INVALID_DATE } from "../../constants";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import {
  saveInprogressEvidenceInstance,
  setIsEvidenceCompleted
} from "../../globalContext/remoteAudit/remoteAuditActions";
import { RemoteAuditContext } from "../../globalContext/remoteAudit/remoteAuditProvider";
import AuditService from "../../services/audit-service";
import MediaService from "../../services/media-service";
import { showNotification } from "../../UtilityFunctions/notification";
import {
  getLocalizedMessage
} from "../../UtilityFunctions/utils";
import CardContainer from "../CardContainer";
import EvidenceContainer from "../EvidenceContainer/EvidenceContainer";
import PreviewCapturing from "../PreviewCapturing";

const MediaContainer = ({
  mediaUploaded,
  setMediaUploaded,
  isVideoCapturing,
  evidenceInProgress,
  hideAction,
  questionId,
  onMediaChanged,
  question,
  responseId,
  fetchResponseId,
}) => {
  const [startCamera, setStartCamera] = useState(false);
  const [mediaUrl, setMediaUrl] = useState(null);
  const [preview, setPreview] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [evidenceNames, setEvidenceNames] = useState([]);

  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [remoteAuditState, remoteAuditDispatch] =
    useContext(RemoteAuditContext);

  const EvidenceKey = isVideoCapturing ? "video" : "snapshot"; // key to update in evidence object
  const isRemote = window.location.pathname.includes("remote");
  const { id, auditId } = useParams();
  const intl = useIntl();

  const startWebcam = () => {
    if (!evidenceInProgress) setStartCamera(true);
    else {
      showNotification(
        "error",
        "Error",
        getLocalizedMessage(intl, "evidence.recordingAudioInProgressWarning")
      );
    }
  };

  const deleteMedia = (mediaId) => {
    MediaService?.deleteMediaData({
      loaderDispatch,
      mediaId,
      intl,
      params: {
        auditId: auditId || id,
        responseId: question?.questionResponse?.responseId || responseId,
      },
    }).then(() => {
      updateEvidencesToPerformDelete(mediaId);
    });
  };

  const updateEvidencesToPerformDelete = (mediaId) => {
    let updatedMedia;
    if (isVideoCapturing) {
      updatedMedia = mediaUploaded?.filter(
        (mediaItem) => mediaItem?.documentId !== mediaId
      );
    } else {
      updatedMedia = mediaUploaded?.filter(
        (mediaItem) => mediaItem !== mediaId
      );
    }
    setMediaUploaded(updatedMedia);
    onMediaChanged(updatedMedia, EvidenceKey);
  };

  const getMediaData = (mediaId) => {
    MediaService?.getMediaData({
      loaderDispatch,
      mediaId: mediaId,
      intl,
    })
      .then((res) => {
        const mediaUrlFromBlob = URL.createObjectURL(res?.data);
        setMediaUrl(mediaUrlFromBlob);
        setPreview(true);
        setStartCamera(true);

        // Clean up the URL when the component is unmounted
        return () => URL.revokeObjectURL(mediaUrlFromBlob);
      })
      .catch(() => {}); //NOSONAR;
  };

  const captureSnapShotRemoteVideoCall = () => {
    const videoElement = document.getElementById("video-local-participant");
    html2canvas(videoElement, { scrollY: -window.scrollY }).then((canvas) => {
      // Convert the canvas to a blob
      canvas.toBlob((blob) => {
        const mediaFile = new File([blob], moment.now(), {
          type: "image/png",
          lastModified: new Date().getTime(),
        });
        const formData = new FormData();
        formData.append("file", mediaFile);
        formData.append("fileName", "media");
        formData.append("type", "SNAPSHOT");
        MediaService.uploadMedia({
          loaderDispatch,
          body: formData,
          queryParams: { type: "SNAPSHOT", auditId: auditId || id, questionId },
          intl,
        }).then((res) => {
          const newMedia = res?.data?.data?.id;
          const newMedias = mediaUploaded?.length
            ? [...mediaUploaded, newMedia]
            : [newMedia];
          setMediaUploaded(newMedias);
          onMediaChanged(newMedias, EvidenceKey);
          fetchResponseId(res?.data?.data?.responseId);
        });
      }, "image/jpeg"); // You can change the image format here
    });
  };

  const captureVideoRecordingRemoteVideoCall = () => {
    if (!remoteAuditState?.isEvidenceCompleted) {
      showNotification(
        "error",
        "Error",
        getLocalizedMessage(intl, "evidence.recordingAudioInProgressWarning")
      );
      return;
    }
    if (
      remoteAuditState?.dnsdSid &&
      remoteAuditState?.mutedVideoParticipent &&
      remoteAuditState?.mutedVideoParticipent[remoteAuditState?.dnsdSid]
    ) {
      showNotification(
        "error",
        "Error",
        getLocalizedMessage(intl, "evidence.cameraOff")
      );
      return;
    }
    const body = {
      auditId: parseInt(auditId || id),
      roomName: remoteAuditState?.room?.roomName,
      recordingType: EvidenceKey,
      recordingAction: 1,
      questionId: parseInt(questionId),
      fileName: `${moment.now()}`,
      participantId: remoteAuditState?.dnsdSid,
    };
    AuditService.recordEvidence({ intl, body }).then((res) => {
      remoteAuditDispatch(setIsEvidenceCompleted(false));
      remoteAuditDispatch(
        saveInprogressEvidenceInstance({
          documentId: parseInt(res?.data?.uploadId?.id),
          responseId: parseInt(res?.data?.responseId),
          type: EvidenceKey,
        })
      );
      fetchResponseId(res?.data?.responseId);
    });
  };

  const getEvidenceName = async (mediaId) => {
    // const res = await MediaService?.getMediaData({
    //   mediaId: mediaId,
    //   intl,
    // });
    // const fileName = getFileNameFromHeaders(
    //   res?.headers?.["content-disposition"]
    // );
    // return fileName;
  };

  useEffect(() => {
    if (mediaUploaded?.length) {
      const fetchEvidenceNames = async () => {
        const names = await Promise.all(
          mediaUploaded?.map((item) => getEvidenceName(item.documentId || item))
        );
        setEvidenceNames(names);
      };
      fetchEvidenceNames();
    }
  }, [mediaUploaded]);


  return (
    <>
      <EvidenceContainer
        disabled={isRemote && !remoteAuditState?.dnsdSid}
        hideAction={hideAction}
        heading={getLocalizedMessage(
          intl,
          isVideoCapturing ? "evidence.videos" : "evidence.snapshots"
        )}
        buttonLabel={getLocalizedMessage(
          intl,
          isVideoCapturing ? "evidence.recordVideo" : "evidence.takeSnapshot"
        )}
        buttonIcon={
          isVideoCapturing
            ? "/icons/play_circle.svg"
            : "/icons/broken_image.svg"
        }
        onButtonClick={
          isRemote
            ? isVideoCapturing
              ? () => {
                  captureVideoRecordingRemoteVideoCall();
                }
              : () => {
                  captureSnapShotRemoteVideoCall();
                }
            : () => startWebcam()
        }
        bottomSectionComponent={mediaUploaded?.map((mediaItem, index) => {
          return (
            <CardContainer
              disabled={hideAction}
              key={mediaItem?.documentId || mediaItem}
              onCrossClick={() =>
                deleteMedia(
                  isVideoCapturing ? mediaItem?.documentId : mediaItem
                )
              }
              title={`${getLocalizedMessage(
                intl,
                isVideoCapturing ? "evidence.video" : "evidence.snap"
              )} ${
                evidenceNames[index] && evidenceNames[index] !== INVALID_DATE
                  ? evidenceNames[index]
                  : index + 1
              }`}
              onIconClick={() => {
                getMediaData(
                  isVideoCapturing ? mediaItem?.documentId : mediaItem
                );
                setSelectedMedia(mediaItem);
              }}
              icon={
                isVideoCapturing
                  ? "/icons/play_circleNew.svg"
                  : "/icons/photo.svg"
              }
            />
          );
        })}
      />
      {startCamera && (
        <PreviewCapturing
          preview={preview}
          setPreview={setPreview}
          mediaUrl={mediaUrl}
          isVideoCapturing={isVideoCapturing}
          setMediaUploaded={setMediaUploaded}
          setStartCamera={setStartCamera}
          mediaUploaded={mediaUploaded}
          selectedMedia={selectedMedia}
          questionId={questionId}
          onMediaChanged={(newSnap) => onMediaChanged(newSnap, EvidenceKey)}
          responseId={responseId}
          fetchResponseId={fetchResponseId}
        />
      )}
    </>
  );
};

export default MediaContainer;
